const toggleClass = function () {
  let className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'scrolled';
  let position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  document.documentElement.classList.toggle(className, window.scrollY > position);
};
export function addClassToDocumentAtScrollY() {
  let className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'scrolled';
  let position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  toggleClass(className, position);
  window.addEventListener('scroll', () => {
    toggleClass(className, position);
  }, {
    passive: true
  });
}